import $ from '@/lib/jquery';
var $globalElements = {
    $mainHeader: function () { return $('#custom-header'); },
    $wpAdminBar: function () { return $('#wpadminbar'); },
};
export default $globalElements;
